import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Breadcrumbs, Button, Card, Input } from '../../../../../components/UI/ComponentsUI';
import ContainerService from '../../../../../services/ContainerService';
import { onValueChange, validateInputsRequired } from '../../../../../utils/handleChangeHooks';
import { translate } from '../../../../../utils/util';
import SelectNew from '../../../../../components/UI/SelectNew';

const PositionInsert = (props) => {
    const [position, setPosition] = useState([]);

    const onChange = (event) => {
        onValueChange(event, position, setPosition);
    };

    const onConfirm = () => {
        if (validateInputsRequired()) {
            props.insertPosition(position, (response) => {
                if (response) {
                    props.history.go(-1);
                }
            });
        }
    };

    return (
        <div>
            <Breadcrumbs id="areaInsert" title={{ icon: "mdi mdi-view-dashboard-outline", label: "Cadastro de Posições" }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <Card>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className="input-field no-padding outlined col s6">
                                <Input
                                    required
                                    maxLength="2"
                                    label="Fila Inicital"
                                    id="queueInitial"
                                    name="queueInitial"
                                    type="text"
                                    onChange={onChange}
                                    defaultValue={position?.queueInitial} />
                            </div>
                            <div className="input-field no-padding outlined col s5">
                                <Input
                                    required
                                    maxLength="2"
                                    label="Fila Final"
                                    id="queueFinal"
                                    name="queueFinal"
                                    type="text"
                                    onChange={onChange}
                                    defaultValue={position?.queueFinal} />
                            </div>
                        </div>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className="input-field no-padding outlined col s6">
                                <Input
                                    required
                                    maxLength={2}
                                    label="Coluna Inicial"
                                    id="columnInitial"
                                    name="columnInitial"
                                    type="number"
                                    numericonly="true"
                                    onChange={onChange}
                                    defaultValue={position?.columnInitial} />
                            </div>
                            <div className="input-field no-padding outlined col s5">
                                <Input
                                    required
                                    maxLength={2}
                                    label="Coluna final"
                                    id="columnFinal"
                                    name="columnFinal"
                                    type="number"
                                    numericonly="true"
                                    onChange={onChange}
                                    defaultValue={position?.columnFinal} />
                            </div>
                        </div>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <Input
                                label="Container Misto"
                                type="checkbox"
                                onChange={onChange}
                                id="containerMixed"
                                name="containerMixed"
                                checked={position.containerMixed}
                            />
                        </div>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            {
                                position.containerMixed ?
                                    <div className="input-field no-padding outlined col s6">
                                        <Input
                                            required
                                            label="Altura"
                                            maxLength={2}
                                            id="heightMaxMixed"
                                            name="heightMaxMixed"
                                            type="number"
                                            numericonly="true"
                                            onChange={onChange}
                                            defaultValue={position?.heightMaxMixed} />
                                    </div> :
                                    <>
                                        <div className="input-field no-padding outlined col s6">
                                            <Input
                                                required
                                                label="Altura CTN Vazio"
                                                maxLength={2}
                                                id="heightMaxEmpty"
                                                name="heightMaxEmpty"
                                                type="number"
                                                numericonly="true"
                                                onChange={onChange}
                                                defaultValue={position?.heightMaxEmpty} />
                                        </div>
                                        <div className="input-field no-padding outlined col s5">
                                            <Input
                                                required
                                                label="Altura CTN Cheio"
                                                maxLength={2}
                                                id="heightMaxFull"
                                                name="heightMaxFull"
                                                numericonly="true"
                                                type="number"
                                                onChange={onChange}
                                                defaultValue={position?.heightMaxFull} />
                                        </div>

                                    </>
                            }
                        </div>
                        <div className="row">
                            <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                            <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        position: state.containerReducer.position,
        containerSizes: state.containerReducer.containerSizes
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        insertPosition: (position, callback) => {
            dispatch(ContainerService.insertPosition(position, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PositionInsert)));
